export default {
  keyboard: require('./keyboard').default,
};
